import { FC, useState, useEffect } from 'react';

import { useParams, useNavigate } from 'react-router-dom';

import { useGetArticleData } from 'hooks/useGetArticleData';
import { useKeyword } from 'hooks/useKeyword';
import { usePageTitle } from 'hooks/usePageTitle';
import { useRemoveRubyTags } from 'hooks/useRemoveRubyTags';

import { Button } from 'components/parts/Button';
import { useGetProgressQuery } from 'store/progress';

import styles from './AnswerCheck.module.scss';

export const AnswerCheck: FC = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id?: string }>();
  const article = useGetArticleData(id || '');
  const { lastResult, isSubmittingKeyword, sendKeyword } = useKeyword(id!);
  const [inputKeyword, setInputKeyword] = useState('');
  const [firstTime, setFirstTime] = useState(false);
  const { refetch: refetchProgress } = useGetProgressQuery();
  const [isError, setIsError] = useState(false);
  const [IsCorrectValue, setIsCorrectValue] = useState(false);

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    if (inputKeyword) {
      await sendKeyword(inputKeyword);
      if (!firstTime) {
        setFirstTime(true);
        setIsError(!lastResult);
      }
    }
  };
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setInputKeyword(event.target.value);
  };
  usePageTitle(useRemoveRubyTags(article?.name));

  useEffect(() => {
    const fetchProgressAndNavigate = async () => {
      if (lastResult) {
        setIsCorrectValue(true);
        // 0.5秒待機
        await new Promise(resolve => setTimeout(resolve, 500));

        // 「progress」を取得し、storeを更新
        await refetchProgress();

        // 完了したらnavigateを実行
        navigate(`/area/answer-result/${id}`);
      }
    };
    fetchProgressAndNavigate();
  }, [lastResult, navigate, id, refetchProgress]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.inner}>
        <div className={styles.header}>
          <p className={styles.text}>
            宝箱は発見できたかな？宝箱を見つけたら、中のキーワードを入力しよう！
          </p>
          <div className={styles.imageWrap}>
            <img
              src={require('images/area/answer/treasure-box.webp')}
              alt=""
              className={styles.image}
            />
          </div>
        </div>
        <div className={styles.body}>
          <form onSubmit={handleSubmit} className={styles.form}>
            <label className={styles.formLabel}>
              宝発見のキーワードを入力<span className={styles.formLabelRequired}>必須</span>
            </label>
            <input
              type="text"
              value={inputKeyword}
              onChange={handleChange}
              placeholder="きーわーど"
              disabled={isSubmittingKeyword}
              className={styles.formInput}
              data-error={!IsCorrectValue && isError}
            />
            {!firstTime ||
              (!lastResult && (
                <p className={styles.formMessage}>宝箱の中に書かれたキーワードを正確に入力してね</p>
              ))}
            <div className={styles.formSubmit}>
              <Button
                text="答え合わせ"
                buttonType="submit"
                styleType="primary"
                addClass={[styles.spotButton]}
              />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
